import { normalLayout } from "./normal";
import { parallaxLayout } from "./parallax";
import { horizontalStackLayout, verticalStackLayout } from "./stack";
export const Layouts = {
  normal: normalLayout,
  parallax: parallaxLayout,
  horizontalStack: horizontalStackLayout,
  verticalStack: verticalStackLayout
};
//# sourceMappingURL=index.js.map